import Vue from "vue"
import { defineStore } from 'pinia'
import { valid } from '../utils/helper'
import * as tus from "tus-js-client";

export const usePageStore = defineStore('page', {
    state: () => ({
        pageModel: {
            pageTitle: null
        },
        variables: {},
        formChilds: {},
    }),

    actions: {
        addFormChild(formName, childTable, refreshFunc, getDataFunc, clearFunc, commitFunc) {
            if (!valid(this.formChilds[formName])) {
                this.formChilds[formName] = [];
            }

            for (let i = 0; i < this.formChilds[formName].length; i++) {
                if (this.formChilds[formName][i].table == childTable) {
                    this.formChilds[formName][i].refresh = refreshFunc;
                    this.formChilds[formName][i].getData = getDataFunc;
                    this.formChilds[formName][i].clear = clearFunc;
                    this.formChilds[formName][i].commit = commitFunc;
                    return;
                }
            }

            this.formChilds[formName].push({
                table: childTable,
                refresh: refreshFunc,
                getData: getDataFunc,
                clear: clearFunc,
                commit: commitFunc,
            })
        },
        getFormChilds(formName) {
            if (!valid(this.formChilds[formName])) {
                return [];
            }

            return this.formChilds[formName]
        },
        setPageTitle(title) {
            this.pageModel.pageTitle = title;
        },
        setPageModelValue(key, value) {
            Vue.set(this.pageModel, key, value)
        },
        setVariableValue(key, value) {
            Vue.set(this.variables, key, value)
        },
    }
})